import { memo } from "react";
import { RegularText } from "src/components/v1";
import { cn } from "src/utilities/shadcnUtils";

export interface AnimatedLabelProps {
  textColor: string;
  borderColor: string;
  borderRadius?: number;
  children: string;
  animated: boolean;
}

const STYLES = {
  container: "absolute top-0 left-0 right-0 w-full flex pointer-events-none [height:calc(100%-18px)]",
  notchedBorderAndLabelContainer: "w-full absolute top-0 left-0 right-0 flex flex-row",
  smallLabel: "whitespace-nowrap mr-[5px] ml-[5px] -mt-2 text-xs",
  fullSizeLabel: "text-gray-500 absolute whitespace-nowrap mr-[5px] ml-6 text-base",
  leftLine: "w-10 h-[46px] border border-solid border-transparent box-border [transform:scaleX(1.05)]",
  rightLine: "w-full h-[46px] border border-solid border-transparent box-border",
  animatedLeftLine: "[transform:scaleX(1.05)_translateX(3px)]",
};

const VARIANTS = {
  animated: { scale: 0.75, y: -10, x: 2, opacity: 0 },
  unanimated: { scale: 1, y: 12 },
};

const AnimatedLabel = ({ textColor, borderColor, borderRadius, animated, children }: AnimatedLabelProps) => (
  <div className={STYLES.container}>
    <div className={STYLES.notchedBorderAndLabelContainer}>
      <div
        className={cn(STYLES.leftLine, (borderRadius || 0) > 10 && animated && STYLES.animatedLeftLine)}
        style={{ borderTopColor: borderColor, borderTopLeftRadius: (borderRadius || 0) + 1 }}
      />
      {animated && (
        <RegularText className={STYLES.smallLabel} style={{ color: textColor }}>
          {children}
        </RegularText>
      )}
      <div
        className={STYLES.rightLine}
        style={{ borderTopColor: borderColor, borderTopRightRadius: borderRadius || 0 }}
      />
    </div>
    <RegularText
      animate={animated ? "animated" : "unanimated"}
      variants={VARIANTS}
      transition={{ duration: 0.1 }}
      className={STYLES.fullSizeLabel}
      style={{ color: textColor }}
    >
      {children}
    </RegularText>
  </div>
);

export default memo(AnimatedLabel);
